// @flow

import { Dropdown } from './dropdown';
import { DropdownList } from './components/list/list';
import { DropdownTypeahead } from './components/typeahead/typeahead';
import { DropdownGroupList, DropdownGroupListTemplate } from './components/group-list';
import { default as DropdownTemplate } from './dropdown.html';
import { default as DropdownListTemplate } from './components/list/list.html';
import { default as DropdownTypeaheadTemplate } from './components/typeahead/typeahead.html';

export * from './dropdown';
export * from './components/group-list';
export * from './components/list/list';
export * from './components/list/list-options';
export * from './components/typeahead/typeahead';
export * from './components/typeahead/typeahead-options';
export * from './contracts';

export const COMPONENTS_DROPDOWN_NAME = 'dropdown'; //nfd-dropdown and so on
export const COMPONENTS_DROPDOWN_LIST_NAME = 'dropdown-list';
export const COMPONENTS_DROPDOWN_TYPEAHEAD_NAME = 'dropdown-typeahead'; //// nfd-dropdown-typeahead
export const COMPONENTS_DROPDOWN_GROUP_LIST_NAME = 'dropdown-group-list';

export const COMPONENTS_DROPDOWN_ENTITIES = [
	{
		name: COMPONENTS_DROPDOWN_NAME,
		entity: Dropdown,
		template: DropdownTemplate,
	}, {
		name: COMPONENTS_DROPDOWN_LIST_NAME,
		entity: DropdownList,
		template: DropdownListTemplate,
	}, {
		name: COMPONENTS_DROPDOWN_TYPEAHEAD_NAME,
		entity: DropdownTypeahead,
		template: DropdownTypeaheadTemplate,
	}, {
		name: COMPONENTS_DROPDOWN_GROUP_LIST_NAME,
		entity: DropdownGroupList,
		template: DropdownGroupListTemplate,
	},
];
